var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIco1 = function SvgIco1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.337 67.869"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ico1_svg__a",
    x1: 0.942,
    x2: 0.11,
    y1: 0.969,
    y2: 0.091,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb100"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18855"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.461 5.4h24.377A7.184 7.184 0 0 1 239 12.561v24.378a7.184 7.184 0 0 1-7.161 7.161h-24.378a7.184 7.184 0 0 1-7.161-7.161V12.561a7.184 7.184 0 0 1 7.161-7.161",
    "data-name": "Path 32934",
    style: {
      fill: "url(#ico1_svg__a)",
      fillRule: "evenodd"
    },
    transform: "translate(-178.16 -5.012)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18859"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.035.3h24.377a7.849 7.849 0 0 1 7.835 7.835v24.377a7.861 7.861 0 0 1-7.835 7.835h-24.377a7.861 7.861 0 0 1-7.835-7.835V8.135A7.861 7.861 0 0 1 203.035.3zm24.377 1.361h-24.377a6.5 6.5 0 0 0-6.474 6.474v24.377a6.485 6.485 0 0 0 6.474 6.474h24.377a6.5 6.5 0 0 0 6.474-6.474V8.135a6.5 6.5 0 0 0-6.474-6.474z",
    "data-name": "Path 32936",
    style: {
      fill: "#272f4d",
      stroke: "#272f4d",
      strokeWidth: ".3px",
      fillRule: "evenodd"
    },
    transform: "translate(-173.06 -.15)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18860"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m260.9 88.365 3.884 3.885 7.677-7.677c3.277-3.29 8.694 2.114 5.4 5.4l-10.61 10.61a3.493 3.493 0 0 1-4.915 0l-6.818-6.818c-3.294-3.286 2.109-8.69 5.382-5.4z",
    "data-name": "Path 32937",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    },
    transform: "translate(-223.521 -72.388)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18861"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.971 83.386 3.4 3.4 7.188-7.188a4.155 4.155 0 0 1 5.88 0 4.268 4.268 0 0 1 .489 6.355L263.273 96.6a4.18 4.18 0 0 1-5.84-.04l-6.818-6.818a4.154 4.154 0 0 1-1.216-2.933c.027-3.648 4.784-6.264 7.572-3.423zm2.92 4.849-3.885-3.885a2.937 2.937 0 0 0-4.439.489 2.807 2.807 0 0 0 0 3.951l6.818 6.818a2.812 2.812 0 0 0 3.924.026l10.649-10.649a2.807 2.807 0 0 0 0-3.951 2.935 2.935 0 0 0-4.439-.476l-7.677 7.677a.67.67 0 0 1-.951 0z",
    "data-name": "Path 32938",
    style: {
      fill: "#272f4d",
      stroke: "#272f4d",
      strokeWidth: ".3px",
      fillRule: "evenodd"
    },
    transform: "translate(-219.099 -67.898)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18862"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.234 198.085H49.1a5.526 5.526 0 0 1 4.651 8.4 5.5 5.5 0 0 1-.37 7.558 4.983 4.983 0 0 1-1.2 5.364 4.88 4.88 0 0 1-4.506 6.646H31.537c-3.739 0-9-2.775-12.737-2.775v-16.79h4.836c2.761-1.15 4.836-5.774 6.25-8.218 1.136-1.982 4.717-5.153 6.474-6.91 2.048-2.286 1.255-8.866 5.814-7.941 5.827 1.467 3.885 10.491 2.061 14.666z",
    "data-name": "Path 32939",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    },
    transform: "translate(-17.967 -158.997)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18868"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.654 343.7a.678.678 0 0 1 1.308.357c0 .026-2.233 8.707-13.556 8.707a.681.681 0 0 1 0-1.361c10.28-.003 12.248-7.676 12.248-7.703z",
    "data-name": "Path 32943",
    style: {
      fill: "#272f4d",
      stroke: "#272f4d",
      strokeWidth: ".3px",
      fillRule: "evenodd"
    },
    transform: "translate(-103.832 -297.756)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18869"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.816 295h6.923a3.495 3.495 0 1 1 0 6.99h-6.923a3.5 3.5 0 0 1 0-6.99",
    "data-name": "Path 32944",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    },
    transform: "translate(-170.333 -255.912)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18873"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.153 289.794h6.923a4.175 4.175 0 1 1 0 8.35h-6.923a4.175 4.175 0 0 1 0-8.35zm6.923 1.361h-6.923a2.814 2.814 0 0 0 0 5.629h6.923a2.815 2.815 0 0 0 .001-5.63z",
    "data-name": "Path 32946",
    style: {
      fill: "#272f4d",
      stroke: "#272f4d",
      strokeWidth: ".3px",
      fillRule: "evenodd"
    },
    transform: "translate(-165.671 -251.393)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18874"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.816 347.9h8.443a3.495 3.495 0 0 1 0 6.989h-8.443a3.5 3.5 0 0 1 0-6.989",
    "data-name": "Path 32947",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    },
    transform: "translate(-170.333 -301.823)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18878"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.39 342.7h8.443a4.175 4.175 0 0 1 0 8.35h-8.443c-5.497-.158-5.51-8.191 0-8.35zm8.443 1.361h-8.443a2.808 2.808 0 0 0 0 5.615h8.443a2.775 2.775 0 0 0 1.982-.832 2.818 2.818 0 0 0-1.982-4.783z",
    "data-name": "Path 32949",
    style: {
      fill: "#272f4d",
      stroke: "#272f4d",
      strokeWidth: ".3px",
      fillRule: "evenodd"
    },
    transform: "translate(-165.907 -297.31)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18879"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.848 400.8h8.443a3.5 3.5 0 0 1 0 7h-8.443c-4.598-.143-4.598-6.881 0-7",
    "data-name": "Path 32950",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    },
    transform: "translate(-165.159 -347.733)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18883"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.153 395.594h8.447a4.165 4.165 0 0 1 2.946 1.229c2.616 2.431.687 7.254-2.946 7.122h-8.443a4.175 4.175 0 0 1 0-8.35zm8.443 1.361h-8.443a2.752 2.752 0 0 0-1.982.832 2.825 2.825 0 0 0 1.982 4.8h8.447a2.815 2.815 0 0 0 0-5.633z",
    "data-name": "Path 32952",
    style: {
      fill: "#272f4d",
      stroke: "#272f4d",
      strokeWidth: ".3px",
      fillRule: "evenodd"
    },
    transform: "translate(-160.464 -343.215)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18884"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.783 453.7h4.1a3.495 3.495 0 0 1 0 6.989h-4.1a3.5 3.5 0 0 1 0-6.989",
    "data-name": "Path 32953",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    },
    transform: "translate(-170.301 -393.644)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18888"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.39 448.5h4.1a4.175 4.175 0 0 1 0 8.35h-4.1c-5.51-.158-5.497-8.191 0-8.35zm4.1 1.361h-4.1a2.8 2.8 0 0 0-1.982.819 2.828 2.828 0 0 0 1.982 4.8h4.1a2.8 2.8 0 0 0 1.982-.819 2.826 2.826 0 0 0-1.986-4.8z",
    "data-name": "Path 32955",
    style: {
      fill: "#272f4d",
      stroke: "#272f4d",
      strokeWidth: ".3px",
      fillRule: "evenodd"
    },
    transform: "translate(-165.907 -389.131)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18889"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.189 221.039a.681.681 0 0 1 0 1.361H27.056c-3.752.026-9.011-2.748-12.737-2.775a.681.681 0 0 1 0-1.361c3.752-.026 9.024 2.748 12.737 2.775zm-28.883-18.18a.681.681 0 0 1 0-1.361H19c2.484-1.2 4.294-5.272 5.827-7.914 1.255-2.1 4.492-4.955 6.58-7.029a20.143 20.143 0 0 0 1.744-4.677c1.07-5.245 7.307-4.162 8.575.185 1.031 3.647.37 7.518-.951 11.033H44.6a.681.681 0 0 1 0 1.361h-4.859a.688.688 0 0 1-.621-.965 20.289 20.289 0 0 0 1.123-3.184 15.272 15.272 0 0 0 .185-7.822c-.344-1.823-3.237-3.7-4.889-2.3-1.334 1.44-1.189 3.277-2.167 5.457a6.346 6.346 0 0 1-1.031 1.916c-1.929 1.916-5.272 4.889-6.368 6.765-1.718 2.92-3.633 7.5-6.844 8.562.013-.026-4.823-.026-4.823-.026z",
    "data-name": "Path 32956",
    style: {
      fill: "#272f4d",
      stroke: "#272f4d",
      strokeWidth: ".3px",
      fillRule: "evenodd"
    },
    transform: "translate(-13.487 -154.681)"
  })));
};
export default SvgIco1;